// export const API_URL = "http://localhost/api"
//  export const API_URL = "http://api-cl.dvl.to/api"
export const API_URL = "https://apidesarrollo.clgranada.com/api"
